import { Chip } from '@appcharge/shared-ui';

import { UIButton } from '../ui';

type CreateOptionContentProps = {
  currentSearchValue: string;
  clearSearch: () => void;
  closeDropdown: () => void;
  editMode: boolean;
  canCreate: (searchValue: string) => boolean;
  onCreate?: (value: string) => void;
  noSearchResultsText?: string;
};

export const CreateOptionContent = ({
  currentSearchValue,
  clearSearch,
  closeDropdown,
  editMode,
  canCreate,
  onCreate,
  noSearchResultsText
}: CreateOptionContentProps) => {
  if (editMode && !currentSearchValue.trim()) return null;

  if (editMode) {
    return (
      <div className="px-2 py-1.5">
        <Chip status="primary" className="bg-[rgba(64,64,64,0.20)] text-neutral-700">
          {currentSearchValue.trim()}
        </Chip>
      </div>
    );
  }

  const showCreateButton = canCreate(currentSearchValue);

  const handleCreateClick = () => {
    if (currentSearchValue.trim() && onCreate) {
      onCreate(currentSearchValue.trim());
      clearSearch();
      closeDropdown();
    }
  };

  return (
    <div>
      <div className="py-1.5 px-2 truncate text-xs font-medium leading-4 text-base-mutedForeground">
        {noSearchResultsText}
      </div>
      {showCreateButton && (
        <UIButton
          variant="ghost"
          className="w-full justify-start text-sm font-normal text-base-accentForeground px-2 pt-2 pb-1.5 hover:bg-[#F4F4F5]"
          onClick={handleCreateClick}
        >
          Create{' '}
          <Chip status="primary" className="bg-[rgba(64,64,64,0.20)] text-neutral-700">
            {currentSearchValue.trim()}
          </Chip>
        </UIButton>
      )}
    </div>
  );
};
